import { useMatch } from 'react-router';

/**
 * «Modo foco» — while the operator declares (`/express`, steps 1–2 of the declare flow;
 * the board at `/express/:urn` is not it), the sidebar folds into its icon rail
 * (`sidebar/sidebar-rail.tsx`, `lg` and up — PO 2026-10-29: the collapsed menu must
 * always show) so the flow keeps the width; below `lg` there is no rail, and the top
 * bar's menu button, otherwise phone-only, shows on a tablet too.
 */
export function useFocusMode(): boolean {
  return useMatch({ path: '/express', end: true }) !== null;
}

/**
 * «Operar la disrupción» — the full-screen operating screen (`/disruptions/:urn/operar`
 * and anything under it): no top bar while on it, and the sidebar folds into its icon
 * rail (`sidebar/sidebar-rail.tsx`) — on a desktop (`lg` and up) only; a phone or a
 * tablet keeps the whole width and no menu. PO 2026-10-27: the ✕ alone did not say the
 * operator was still inside the console, so the rail keeps the map one click away. The
 * screen brings its own frame — beside the rail, filling the shell's <main> — and
 * leaves through its own ✕ (back to the Tower). The rehearsal strip (#812) stays above
 * the screen — the frame fills <main>, never the viewport. The reconnection pill moves
 * under the screen's own header (the shell leaves it out here), so it never covers the
 * header's state badge.
 */
export function useImmersiveMode(): boolean {
  return useMatch({ path: '/disruptions/:disruptionUrn/operar', end: false }) !== null;
}
